module.exports = __webpack_public_path__ + "static/media/happiness-icon-neutral.be523c80.svg";